define('viewmodels/pages/cash/history',['knockout'], function (ko) {

    var HistoryViewModel = function(session, navigation, getField, cashTabs, TransactionListViewModel, BetListViewModel) {
        var self = this;

        self.subNav = cashTabs;

        self.meta = {
            title: getField('meta_title'),
            description: getField('meta_description')
        };

        self.fields = {
            transactionTab: getField('transaction_tab_title'),
            betsTab: getField('bets_tab_title'),
            transactionsTitle: getField('title'),
            noTransactionsText: getField('no_transactions_text')
        };

        self.showBets = ko.pureComputed(function() {
            return navigation.getRouter().activeInstruction().config.id === navigation.ROUTES.HISTORY_BETS;
        });

        self.transactions = ko.deferredComputed(function() {
            return session.getAssociatedPlayer().payments.nonRollbackTransactions();
        });

        self.transactionsList = new TransactionListViewModel(self.transactions);

        self.betsList = new BetListViewModel();

    };

    return HistoryViewModel;
});


